import { FormEvent, useState } from "react";
import Button from "../components/Button";
import Footer from "../components/Footer";
import Form from "../components/Form";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import { sendBooking } from "../services/api";
import { useNotification } from "../contexts/NotificationContext";
import ScrollToTop from "react-scroll-to-top";

// CONST

const desc =
	"Remplissez le formulaire ci-contre pour faire une demande de réservation." +
	"Notre équipe vous confirmera la disponibilité par e-mail ou message dans les meilleurs délais.";

// COMPONENT

function Booking() {
	const { notify } = useNotification();
	// STATES
	const [isSending, setIsSending] = useState<boolean>(false);
	// HANDLES
	const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setIsSending(true);
		const data = new FormData(e.currentTarget);
		const name = data.get("nom") as string;
		const firstname = data.get("prenom") as string;
		const mail = data.get("mail") as string;
		const phone = data.get("tel") as string;
		const people = data.get("personnes") as string;
		const time = data.get("time") as string;
		const date = data.get("date") as string;
		const request =
			"Demande de réservation pour " +
			people +
			" personnes le " +
			date +
			" à " +
			time +
			" de la part de " +
			name +
			" " +
			firstname +
			"\n\n" +
			mail +
			"\n" +
			phone;
		const response = await sendBooking(request);
		setIsSending(false);
		if (response) {
			notify({
				type: "validation",
				title: "Réservation Envoyée",
				subtitle: "Votre demande à été prise en compte",
			});
			const resetForm = e.target as HTMLFormElement;
			resetForm.reset();
		} else {
			notify({ type: "error", title: "Demande Échouée..." });
		}
	};
	// COMPONENT
	return (
		<div className="booking">
			<Navbar />
			<Hero
				title="RÉSERVATIONS"
				subtitle="Votre Moment au Petit Bar"
				image="/assets/hero/réservations.jpg"
				showSchedule={true}
			/>
			<section className="form-section">
				<Form title="Demandez Une Réservation" description={desc}>
					<form onSubmit={(e) => handleSubmit(e)}>
						<div>
							<input
								type="text"
								name="prenom"
								placeholder="Prénom"
								required
							/>
							<input type="text" name="nom" placeholder="Nom" />
						</div>
						<input
							type="mail"
							name="mail"
							placeholder="nom.prenom@mail.com"
							required
						/>
						<div>
							<input
								type="number"
								name="personnes"
								placeholder="NB.personnes"
								required
							/>
							<input
								type="tel"
								name="tel"
								placeholder="01 02 03 04 05"
								required
							/>
						</div>
						<div>
							<input
								type="date"
								name="date"
								placeholder="DD/MM/YYYY"
								required
							/>
							<input
								type="time"
								name="time"
								placeholder="HHMM"
								required
							/>
						</div>
						<button type="submit" disabled={isSending}>
							<span className="primary-text">ENVOYER</span>
						</button>
					</form>
				</Form>
			</section>
			<Footer />
		</div>
	);
}

export default Booking;
